const timesheetSystemServiceServiceName = "/Timesheet";

export function timesheetSystemService(http) {
    return {
        getPersonnelTimesheetData: async (personnelCode, userName, fromDate, toDate, isMonthly) => {
            var param = {
                "PersonnelCode": personnelCode,
                "UserName": userName,
                "FromDate": fromDate,
                "ToDate": toDate,
                "IsMonthly": isMonthly            
            }
            return await http.post(timesheetSystemServiceServiceName + "/GetPersonnelCommute", param);
        },
        getDailyWorkingData: async (personnelCode, persianSpecifiedDate) => {
            return await http.post(timesheetSystemServiceServiceName + "/GetDailyWorkingData", 
                { personnelCode, persianSpecifiedDate});
        },
        getPersonnelTimesheets: (personnelCode, fromDate, toDate) => {
            var param = {
                "PersonnelCode": personnelCode,
                "FromDate": fromDate,
                "ToDate": toDate
            }
            return http.post(timesheetSystemServiceServiceName + "/GetPersonnelTimesheets", param);
        },        
        saveTimesheetAsync: async (personnelCode, activityCode, activityDiscipline, costCenterCode,secondActivityCode,
            secondActivityDisciplineCode, secondCostCenterCode, date, jalaliDate, basic, overtime, mission, 
            homework, curtrentUser, userName, isBulkSaving,)  => {
                debugger;
            let timesheetParam = {
                PersonnelCode: personnelCode,
                ActivityCode: activityCode,
                ActivityDiscipline: activityDiscipline,
                CostCenterCode: costCenterCode,                
                Date: date,
                Basic: basic,
                Overtime: overtime,
                Mission: mission,
                Homework: homework,
                CurrentUser: curtrentUser,
                UserName: userName,
                IsBulkSaving: isBulkSaving,
                JalaliToday: jalaliDate,
                secondActivityCode,
                secondActivityDisciplineCode, 
                secondCostCenterCode
            }

            debugger;
            return await http.post(timesheetSystemServiceServiceName + "/SaveTimesheetAsync", timesheetParam);
        },
        updateTimesheetAsync: async (id, personnelCode, activityCode, activityDiscipline, costCenterCode, date, jalaliDate,
            basic, overtime, mission, homework, curtrentUser, userName)  => {    
            let timesheetParam = {
                Id: id,
                PersonnelCode: personnelCode,
                ActivityCode: activityCode,
                ActivityDiscipline: activityDiscipline,
                CostCenterCode: costCenterCode,                
                Date: date,
                Basic: basic,
                Overtime: overtime,
                Mission: mission,
                Homework: homework,
                CurrentUser: curtrentUser,
                UserName: userName,
                JalaliToday: jalaliDate
            }   
            return await http.post(timesheetSystemServiceServiceName + "/UpdateTimesheetAsync", timesheetParam);
        },
        deleteTimesheetAsync: async (personnelCode, activityCode, activityDiscipline, costCenterCode, date, JalaliDate) => {
            let param = {
                PersonnelCode: personnelCode,
                ActivityCode: activityCode,
                ActivityDiscipline: activityDiscipline,
                CostCenterCode: costCenterCode,
                Date: date,
                JalaliToday: JalaliDate
            }
            return await http.post(timesheetSystemServiceServiceName + "/DeleteTimesheetAsync", param);
        },
        getRemainingTimeAsync: async (personnelCode, date, userName) => {
            let param = {
                PersonnelCode: personnelCode,
                Date: date,
                UserName: userName
            }
            return await http.post(timesheetSystemServiceServiceName + "/GetRemainingHoursAsync", param);

        },        
        bulkSaveTimesheetAsync: async (personnelCode, activityCode, activityDiscipline, costCenterCode, date,
            basic, overtime, mission, homework, curtrentUser, userName, duplicateType, duplicateNumber)  => {    
            let timesheetParam = {
                PersonnelCode: personnelCode,
                ActivityCode: activityCode,
                ActivityDiscipline: activityDiscipline,
                CostCenterCode: costCenterCode,                
                Date: date,
                Basic: basic,
                Overtime: overtime,
                Mission: mission,
                Homework: homework,
                CurrentUser: curtrentUser,
                UserName: userName,
                DuplicateType: duplicateType,
                DuplicateNumber: duplicateNumber
            }   
            return await http.post(timesheetSystemServiceServiceName + "/BulkSaveTimesheetAsync", timesheetParam);
        }
    }
    
}